// model Phần câu hỏi
export type Session = {
  id?: string;
  name?: string;
  description?: string;
  title?: string;
  questions?: Question[];
};

// model khảo sát
export type SessionMetadata = {
  id: string;
  title: string;
  aliasName: string;
  validDate: number;
  description: string;
  descriptionLast?: string;
  sectionIdLast?: string;
  image?: string;
  // trạng thái
  status: boolean;
  customerName?: string;
};

// model câu hỏi
export type Question = {
  id: string;
  title?: string;
  answers?: any[];
  type: QuestionType;
  hasPoint?: boolean;
  required?: boolean;
};

// enum cho loại câu hỏi
export enum QuestionType {
  QUIZ = 'TN',
  MULTI_CHOICE = 'HK',
  SHORT_ANSWER = 'TLN',
  LONG_ANSWER = 'TLD',
  RATE = 'RATE',
}

export type SurveyModel = { metadata: SessionMetadata } & { [key: string]: Session };
